// User & Auth
export var UserRole;
(function (UserRole) {
    UserRole["SUPER_ADMIN"] = "super_admin";
    UserRole["ADMIN"] = "admin";
    UserRole["DISPATCHER"] = "dispatcher";
    UserRole["MANAGER"] = "manager";
    UserRole["VIEWER"] = "viewer";
    UserRole["DRIVER"] = "driver";
    UserRole["CARRIER"] = "carrier";
    UserRole["CUSTOMER"] = "customer";
})(UserRole || (UserRole = {}));
// Load Management
export var LoadStatus;
(function (LoadStatus) {
    LoadStatus["DRAFT"] = "draft";
    LoadStatus["QUOTED"] = "quoted";
    LoadStatus["TENDERED"] = "tendered";
    LoadStatus["PENDING"] = "pending";
    LoadStatus["DISPATCHED"] = "dispatched";
    LoadStatus["EN_ROUTE"] = "en_route";
    LoadStatus["AT_PICKUP"] = "at_pickup";
    LoadStatus["IN_TRANSIT"] = "in_transit";
    LoadStatus["AT_DELIVERY"] = "at_delivery";
    LoadStatus["DELIVERED"] = "delivered";
    LoadStatus["COMPLETED"] = "completed";
    LoadStatus["INVOICED"] = "invoiced";
    LoadStatus["SETTLED"] = "settled";
    LoadStatus["CANCELLED"] = "cancelled";
})(LoadStatus || (LoadStatus = {}));
// Equipment
export var EquipmentType;
(function (EquipmentType) {
    EquipmentType["TRUCK"] = "truck";
    EquipmentType["TRAILER"] = "trailer";
    EquipmentType["CONTAINER"] = "container";
    EquipmentType["CHASSIS"] = "chassis";
})(EquipmentType || (EquipmentType = {}));
export var EquipmentStatus;
(function (EquipmentStatus) {
    EquipmentStatus["ACTIVE"] = "active";
    EquipmentStatus["INACTIVE"] = "inactive";
    EquipmentStatus["IN_MAINTENANCE"] = "in_maintenance";
    EquipmentStatus["RETIRED"] = "retired";
})(EquipmentStatus || (EquipmentStatus = {}));
// Drivers
export var DriverStatus;
(function (DriverStatus) {
    DriverStatus["ACTIVE"] = "active";
    DriverStatus["INACTIVE"] = "inactive";
    DriverStatus["ON_LEAVE"] = "on_leave";
    DriverStatus["TERMINATED"] = "terminated";
})(DriverStatus || (DriverStatus = {}));
// Carriers
export var CarrierStatus;
(function (CarrierStatus) {
    CarrierStatus["ACTIVE"] = "active";
    CarrierStatus["INACTIVE"] = "inactive";
    CarrierStatus["BLACKLISTED"] = "blacklisted";
    CarrierStatus["PENDING"] = "pending";
})(CarrierStatus || (CarrierStatus = {}));
// Suppliers (WAYP-608) — sibling module to Carriers. The V1 `is_carrier`
// dual-role flag is intentionally not ported, and `blacklisted` is omitted
// from this enum because the concept does not apply to vendor records.
// Mirrors the Prisma `SupplierStatus` enum from WAYP-607.
export var SupplierStatus;
(function (SupplierStatus) {
    SupplierStatus["ACTIVE"] = "active";
    SupplierStatus["INACTIVE"] = "inactive";
    SupplierStatus["PENDING"] = "pending";
})(SupplierStatus || (SupplierStatus = {}));
// Carrier Compliance
export var RequirementType;
(function (RequirementType) {
    RequirementType["INSURANCE_CERT"] = "insurance_cert";
    RequirementType["OPERATING_AUTHORITY"] = "operating_authority";
    RequirementType["W9"] = "w9";
    RequirementType["SAFETY_RATING"] = "safety_rating";
    RequirementType["CARGO_INSURANCE"] = "cargo_insurance";
})(RequirementType || (RequirementType = {}));
export var RequirementStatus;
(function (RequirementStatus) {
    RequirementStatus["PENDING"] = "pending";
    RequirementStatus["APPROVED"] = "approved";
    RequirementStatus["EXPIRED"] = "expired";
    RequirementStatus["MISSING"] = "missing";
})(RequirementStatus || (RequirementStatus = {}));
// Locations
export var LocationType;
(function (LocationType) {
    LocationType["TERMINAL"] = "terminal";
    LocationType["CUSTOMER"] = "customer";
    LocationType["WAREHOUSE"] = "warehouse";
    LocationType["PORT"] = "port";
    LocationType["YARD"] = "yard";
    LocationType["CROSS_DOCK"] = "cross_dock";
})(LocationType || (LocationType = {}));
// Stop Management
export var StopType;
(function (StopType) {
    StopType["PICKUP"] = "pickup";
    StopType["DELIVERY"] = "delivery";
    StopType["STOP"] = "stop";
    StopType["RELAY"] = "relay";
    StopType["CROSS_DOCK"] = "cross_dock";
})(StopType || (StopType = {}));
export var StopStatus;
(function (StopStatus) {
    StopStatus["PENDING"] = "pending";
    StopStatus["ARRIVED"] = "arrived";
    StopStatus["LOADING"] = "loading";
    StopStatus["UNLOADING"] = "unloading";
    StopStatus["COMPLETED"] = "completed";
    StopStatus["SKIPPED"] = "skipped";
})(StopStatus || (StopStatus = {}));
// Quoting
//
// WAYP-814: V1 Quote-form Status dropdown surfaces only ACCEPTED /
// NEW_LOAD_TENDER / REJECTED. Existing values (DRAFT/SENT/DECLINED/EXPIRED/
// CONVERTED) remain valid for system-generated transitions and stay in
// the enum for backwards compatibility — they are simply not user-selectable
// in the form picker.
export var QuoteStatus;
(function (QuoteStatus) {
    QuoteStatus["DRAFT"] = "draft";
    QuoteStatus["SENT"] = "sent";
    QuoteStatus["ACCEPTED"] = "accepted";
    QuoteStatus["DECLINED"] = "declined";
    QuoteStatus["EXPIRED"] = "expired";
    QuoteStatus["CONVERTED"] = "converted";
    QuoteStatus["NEW_LOAD_TENDER"] = "new_load_tender";
    QuoteStatus["REJECTED"] = "rejected";
    // WAYP-814: contributed by the Quotable+Dispatch `load_statuses` seed
    // (Company Preferences `enableQuotes` toggle). Maps 1:1 with the
    // seeded statusName values (lower-cased + underscored).
    QuoteStatus["OPEN"] = "open";
    QuoteStatus["CONFIRMED"] = "confirmed";
    QuoteStatus["CLOSED"] = "closed";
    QuoteStatus["CANCELLED"] = "cancelled";
    QuoteStatus["CANCELLATION_ACCEPTED"] = "cancellation_accepted";
})(QuoteStatus || (QuoteStatus = {}));
// USPS-CONTRACTS-06 (2026-04-29): generic `ContractStatus` enum removed.
// The generic `Contract` model has been retired entirely; the V1-parity
// replacement is `UspsContractStatus` (active|completed) below.
// USPS Contracts (USPS-CONTRACTS-V2, 2026-04-29)
// V1-parity rebuild on `UspsContract`. Replaces the legacy
// `hcr|mail_transport|emergency` triple with HCR / LRO / MTEC / NOMILES
// and collapses the status enum from `active|expired|pending` to V1's
// `active|completed`. Mirrors the Prisma `UspsContractType` and
// `UspsContractStatusEnum` enums.
export var UspsContractType;
(function (UspsContractType) {
    UspsContractType["HCR"] = "HCR";
    UspsContractType["LRO"] = "LRO";
    UspsContractType["MTEC"] = "MTEC";
    UspsContractType["NOMILES"] = "NOMILES";
})(UspsContractType || (UspsContractType = {}));
export var UspsContractStatus;
(function (UspsContractStatus) {
    UspsContractStatus["ACTIVE"] = "active";
    UspsContractStatus["COMPLETED"] = "completed";
})(UspsContractStatus || (UspsContractStatus = {}));
// Billing & Invoicing
export var InvoiceStatus;
(function (InvoiceStatus) {
    InvoiceStatus["DRAFT"] = "draft";
    InvoiceStatus["SENT"] = "sent";
    InvoiceStatus["PAID"] = "paid";
    InvoiceStatus["OVERDUE"] = "overdue";
    InvoiceStatus["VOID"] = "void";
})(InvoiceStatus || (InvoiceStatus = {}));
export var SettlementType;
(function (SettlementType) {
    SettlementType["DRIVER_PAY"] = "driver_pay";
    SettlementType["CARRIER_PAY"] = "carrier_pay";
})(SettlementType || (SettlementType = {}));
// Customer credit-limit status (WAYP credit-summary). Mirrors the Prisma
// `CreditStatus` enum 1:1 — values MUST equal the DB enum labels so they
// round-trip over the wire. Derived from the denormalized credit summary by
// `deriveCreditStatus` (lib/credit-status.ts), stored on `Customer.creditStatus`.
export var CreditStatus;
(function (CreditStatus) {
    CreditStatus["NO_LIMIT"] = "NO_LIMIT";
    CreditStatus["WITHIN_LIMIT"] = "WITHIN_LIMIT";
    CreditStatus["NEARING_LIMIT"] = "NEARING_LIMIT";
    CreditStatus["OVER_LIMIT"] = "OVER_LIMIT";
    CreditStatus["LOCKED"] = "LOCKED";
})(CreditStatus || (CreditStatus = {}));
// WAYP-814: V1 quote-form Settlement payment-type enum. Mirrors the Prisma
// `SettlementPaymentType` enum 1:1. Keep in sync with
// packages/server/src/core/quotes/quote.dto.ts.
export var SettlementPaymentType;
(function (SettlementPaymentType) {
    SettlementPaymentType["FLAT_RATE"] = "flat_rate";
    SettlementPaymentType["MILEAGE"] = "mileage";
    SettlementPaymentType["PERCENTAGE"] = "percentage";
    SettlementPaymentType["HOURLY"] = "hourly";
})(SettlementPaymentType || (SettlementPaymentType = {}));
export var SettlementStatus;
(function (SettlementStatus) {
    SettlementStatus["PENDING"] = "pending";
    SettlementStatus["APPROVED"] = "approved";
    SettlementStatus["PAID"] = "paid";
})(SettlementStatus || (SettlementStatus = {}));
export var RateMethod;
(function (RateMethod) {
    RateMethod["FLAT"] = "flat";
    RateMethod["PER_MILE"] = "per_mile";
    RateMethod["PER_CWT"] = "per_cwt";
    RateMethod["PER_HOUR"] = "per_hour";
    RateMethod["PERCENTAGE"] = "percentage";
})(RateMethod || (RateMethod = {}));
export var BillableTo;
(function (BillableTo) {
    BillableTo["CUSTOMER"] = "customer";
    BillableTo["DRIVER"] = "driver";
    BillableTo["CARRIER"] = "carrier";
})(BillableTo || (BillableTo = {}));
// Dock Management
export var DoorType;
(function (DoorType) {
    DoorType["INBOUND"] = "inbound";
    DoorType["OUTBOUND"] = "outbound";
    DoorType["DUAL"] = "dual";
})(DoorType || (DoorType = {}));
export var DoorStatus;
(function (DoorStatus) {
    DoorStatus["AVAILABLE"] = "available";
    DoorStatus["OCCUPIED"] = "occupied";
    DoorStatus["RESERVED"] = "reserved";
    DoorStatus["MAINTENANCE"] = "maintenance";
    DoorStatus["BLOCKED"] = "blocked";
})(DoorStatus || (DoorStatus = {}));
// Cross Dock Appointments
export var AppointmentType;
(function (AppointmentType) {
    AppointmentType["INBOUND"] = "inbound";
    AppointmentType["OUTBOUND"] = "outbound";
})(AppointmentType || (AppointmentType = {}));
export var AppointmentStatus;
(function (AppointmentStatus) {
    AppointmentStatus["SCHEDULED"] = "scheduled";
    AppointmentStatus["CHECKED_IN"] = "checked_in";
    AppointmentStatus["IN_PROGRESS"] = "in_progress";
    AppointmentStatus["COMPLETED"] = "completed";
    AppointmentStatus["NO_SHOW"] = "no_show";
    AppointmentStatus["CANCELLED"] = "cancelled";
})(AppointmentStatus || (AppointmentStatus = {}));
// Staging
export var StagingZoneType;
(function (StagingZoneType) {
    StagingZoneType["GENERAL"] = "general";
    StagingZoneType["REEFER"] = "reefer";
    StagingZoneType["HAZMAT"] = "hazmat";
    StagingZoneType["OVERSIZED"] = "oversized";
})(StagingZoneType || (StagingZoneType = {}));
export var StagingItemStatus;
(function (StagingItemStatus) {
    StagingItemStatus["STAGED"] = "staged";
    StagingItemStatus["SORTED"] = "sorted";
    StagingItemStatus["LOADING"] = "loading";
    StagingItemStatus["LOADED"] = "loaded";
    StagingItemStatus["DAMAGED"] = "damaged";
    StagingItemStatus["MISSING"] = "missing";
})(StagingItemStatus || (StagingItemStatus = {}));
// Yard Management
export var YardSpotStatus;
(function (YardSpotStatus) {
    YardSpotStatus["EMPTY"] = "empty";
    YardSpotStatus["OCCUPIED"] = "occupied";
    YardSpotStatus["RESERVED"] = "reserved";
})(YardSpotStatus || (YardSpotStatus = {}));
// EDI
export var EdiTransactionSet;
(function (EdiTransactionSet) {
    EdiTransactionSet["SHIPMENT_210"] = "210";
    EdiTransactionSet["SHIPMENT_214"] = "214";
    EdiTransactionSet["CARRIER_204"] = "204";
    EdiTransactionSet["FUNCTIONAL_ACKNOWLEDGMENT_997"] = "997";
    EdiTransactionSet["INTERCHANGE_ACKNOWLEDGMENT_TA1"] = "TA1";
})(EdiTransactionSet || (EdiTransactionSet = {}));
export var EdiDirection;
(function (EdiDirection) {
    EdiDirection["INBOUND"] = "inbound";
    EdiDirection["OUTBOUND"] = "outbound";
})(EdiDirection || (EdiDirection = {}));
export var EdiStatus;
(function (EdiStatus) {
    EdiStatus["RECEIVED"] = "received";
    EdiStatus["PROCESSING"] = "processing";
    EdiStatus["PROCESSED"] = "processed";
    EdiStatus["ERROR"] = "error";
    EdiStatus["TRANSMITTED"] = "transmitted";
})(EdiStatus || (EdiStatus = {}));
// Audit
export var AuditAction;
(function (AuditAction) {
    AuditAction["CREATE"] = "create";
    AuditAction["UPDATE"] = "update";
    AuditAction["DELETE"] = "delete";
    AuditAction["STATUS_CHANGE"] = "status_change";
    AuditAction["LOGIN"] = "login";
    AuditAction["EXPORT"] = "export";
})(AuditAction || (AuditAction = {}));
// Chat
export var ChatRole;
(function (ChatRole) {
    ChatRole["USER"] = "user";
    ChatRole["ASSISTANT"] = "assistant";
    ChatRole["SYSTEM"] = "system";
})(ChatRole || (ChatRole = {}));
export var ChatContextType;
(function (ChatContextType) {
    ChatContextType["GENERAL"] = "general";
    ChatContextType["DISPATCH"] = "dispatch";
    ChatContextType["REPORTS"] = "reports";
    ChatContextType["LOAD_DETAIL"] = "load_detail";
})(ChatContextType || (ChatContextType = {}));
// AI Dispatch
export var SuggestionType;
(function (SuggestionType) {
    SuggestionType["ROUTE_OPTIMIZE"] = "route_optimize";
    SuggestionType["DRIVER_ASSIGN"] = "driver_assign";
    SuggestionType["EQUIPMENT_MATCH"] = "equipment_match";
    SuggestionType["SCHEDULE"] = "schedule";
    SuggestionType["CONSOLIDATE"] = "consolidate";
})(SuggestionType || (SuggestionType = {}));
export var SuggestionStatus;
(function (SuggestionStatus) {
    SuggestionStatus["PENDING"] = "pending";
    SuggestionStatus["ACCEPTED"] = "accepted";
    SuggestionStatus["DISMISSED"] = "dismissed";
    SuggestionStatus["EXPIRED"] = "expired";
})(SuggestionStatus || (SuggestionStatus = {}));
// DAT
export var DatRateType;
(function (DatRateType) {
    DatRateType["SPOT"] = "spot";
    DatRateType["CONTRACT"] = "contract";
})(DatRateType || (DatRateType = {}));
export var DatPostingStatus;
(function (DatPostingStatus) {
    DatPostingStatus["ACTIVE"] = "active";
    DatPostingStatus["MATCHED"] = "matched";
    DatPostingStatus["EXPIRED"] = "expired";
    DatPostingStatus["CANCELLED"] = "cancelled";
})(DatPostingStatus || (DatPostingStatus = {}));
// Customers
export var CustomerType;
(function (CustomerType) {
    CustomerType["SHIPPER"] = "shipper";
    CustomerType["CONSIGNEE"] = "consignee";
    CustomerType["BROKER"] = "broker";
    CustomerType["CUSTOMER"] = "customer";
})(CustomerType || (CustomerType = {}));
export var CustomerStatus;
(function (CustomerStatus) {
    CustomerStatus["ACTIVE"] = "active";
    CustomerStatus["INACTIVE"] = "inactive";
})(CustomerStatus || (CustomerStatus = {}));
// Equipment Maintenance
export var MaintenanceType;
(function (MaintenanceType) {
    MaintenanceType["OIL_CHANGE"] = "oil_change";
    MaintenanceType["TIRE_ROTATION"] = "tire_rotation";
    MaintenanceType["BRAKE_INSPECTION"] = "brake_inspection";
    MaintenanceType["ANNUAL_DOT"] = "annual_dot";
    MaintenanceType["CUSTOM"] = "custom";
})(MaintenanceType || (MaintenanceType = {}));
// Equipment Expiry
export var ExpiryType;
(function (ExpiryType) {
    ExpiryType["REGISTRATION"] = "registration";
    ExpiryType["INSPECTION"] = "inspection";
    ExpiryType["INSURANCE"] = "insurance";
    ExpiryType["PERMIT"] = "permit";
})(ExpiryType || (ExpiryType = {}));
// Rate Management
export var SeasonalAdjustmentType;
(function (SeasonalAdjustmentType) {
    SeasonalAdjustmentType["FLAT"] = "flat";
    SeasonalAdjustmentType["PERCENTAGE"] = "percentage";
})(SeasonalAdjustmentType || (SeasonalAdjustmentType = {}));
// Payments
export var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["CHECK"] = "check";
    PaymentMethod["ACH"] = "ach";
    PaymentMethod["WIRE"] = "wire";
    PaymentMethod["CREDIT_CARD"] = "credit_card";
})(PaymentMethod || (PaymentMethod = {}));
// Driver Time Off
export var TimeOffType;
(function (TimeOffType) {
    TimeOffType["VACATION"] = "vacation";
    TimeOffType["SICK"] = "sick";
    TimeOffType["PERSONAL"] = "personal";
})(TimeOffType || (TimeOffType = {}));
export var TimeOffStatus;
(function (TimeOffStatus) {
    TimeOffStatus["PENDING"] = "pending";
    TimeOffStatus["APPROVED"] = "approved";
    TimeOffStatus["DENIED"] = "denied";
})(TimeOffStatus || (TimeOffStatus = {}));
// Trips (WAYP-167)
export var TripStatus;
(function (TripStatus) {
    TripStatus["PLANNING"] = "planning";
    TripStatus["ACTIVE"] = "active";
    TripStatus["IN_PROGRESS"] = "in_progress";
    TripStatus["COMPLETED"] = "completed";
    TripStatus["CANCELLED"] = "cancelled";
})(TripStatus || (TripStatus = {}));
// Driver Deductions
export var DeductionType;
(function (DeductionType) {
    DeductionType["LOAN_PAYMENT"] = "loan_payment";
    DeductionType["INSURANCE"] = "insurance";
    DeductionType["FUEL_ADVANCE"] = "fuel_advance";
    DeductionType["ESCROW"] = "escrow";
    DeductionType["CUSTOM"] = "custom";
})(DeductionType || (DeductionType = {}));
// #1140 — V1-parity D/R discriminator. A DriverDeduction row's `kind`
// decides whether it subtracts from (deduction) or adds to
// (reimbursement) the settlement total.
export var DeductionKind;
(function (DeductionKind) {
    DeductionKind["DEDUCTION"] = "deduction";
    DeductionKind["REIMBURSEMENT"] = "reimbursement";
})(DeductionKind || (DeductionKind = {}));
// #1140 — Recurring D/R cadence. Matches V1's `frequency` option set.
export var RecurringFrequency;
(function (RecurringFrequency) {
    RecurringFrequency["WEEKLY"] = "weekly";
    RecurringFrequency["BIWEEKLY"] = "biweekly";
    RecurringFrequency["MONTHLY"] = "monthly";
    RecurringFrequency["QUARTERLY"] = "quarterly";
    RecurringFrequency["YEARLY"] = "yearly";
})(RecurringFrequency || (RecurringFrequency = {}));
// Notification Center (#1535)
//
// `module` = the product surface the notification belongs to. Drives the
// /notifications page module-filter dropdown + the per-row badge colour.
// Mirrors the Prisma `NotificationModule` enum 1:1; the two MUST stay in
// lockstep across both packages (database + API + UI).
export var NotificationModule;
(function (NotificationModule) {
    NotificationModule["SUPPORT"] = "support";
    NotificationModule["DISPATCH"] = "dispatch";
    NotificationModule["FINANCE"] = "finance";
    NotificationModule["USPS"] = "usps";
    NotificationModule["INTERMODAL"] = "intermodal";
    NotificationModule["FTL_BROKERAGE"] = "ftl_brokerage";
    NotificationModule["LIVESTOCK"] = "livestock";
    NotificationModule["SYSTEM"] = "system";
})(NotificationModule || (NotificationModule = {}));
// `category` = sub-bucket within the module. Values inferred from the
// existing `support_ticket_*` notification `type` strings (priority /
// status / assignee / comment) plus a generic `info` fallback that
// future emitters can use without expanding the enum. Mirrors the
// Prisma `NotificationCategory` enum 1:1.
export var NotificationCategory;
(function (NotificationCategory) {
    NotificationCategory["TICKET_CREATED"] = "ticket_created";
    NotificationCategory["TICKET_UPDATED"] = "ticket_updated";
    NotificationCategory["COMMENT_ADDED"] = "comment_added";
    NotificationCategory["STATUS_CHANGED"] = "status_changed";
    NotificationCategory["PRIORITY_CHANGED"] = "priority_changed";
    NotificationCategory["ASSIGNEE_CHANGED"] = "assignee_changed";
    NotificationCategory["INFO"] = "info";
})(NotificationCategory || (NotificationCategory = {}));
// `severity` = visual weight of the notification card. String column on
// the model (not a Postgres enum) so module emitters can pick an
// arbitrary level without a schema round-trip. The client renders any
// unknown value as `info`.
export var NotificationSeverity;
(function (NotificationSeverity) {
    NotificationSeverity["INFO"] = "info";
    NotificationSeverity["SUCCESS"] = "success";
    NotificationSeverity["WARNING"] = "warning";
    NotificationSeverity["ERROR"] = "error";
})(NotificationSeverity || (NotificationSeverity = {}));
// `readState` = the /notifications page filter for the `readAt` column.
// Replaces the legacy boolean `unreadOnly` so the URL can carry "all"
// vs "read" vs "unread" cleanly.
export var NotificationReadState;
(function (NotificationReadState) {
    NotificationReadState["ALL"] = "all";
    NotificationReadState["READ"] = "read";
    NotificationReadState["UNREAD"] = "unread";
})(NotificationReadState || (NotificationReadState = {}));
//# sourceMappingURL=enums.js.map